import { API_MAP, agent } from 'helpers';
class NutrorService {
  static listNutrorCourses() {
    return agent.get(`${API_MAP.listNutrorCourses}`);
  }

  static uploadNutrorCourses(idProduct: number, idCourse: number, course: string, type: string) {
    return agent.post(`${API_MAP.uploadDeliveryProviders}`.replace('{id}', idProduct.toString()), {
      deliveries: [{ nutror_id: idCourse, nutror_name: course, type, method_id: 24 }],
    });
  }
}

export default NutrorService;
